import { FunctionComponent, useContext } from 'react'
import { ThemeContext } from 'styled-components'

import TestimonialsABTest from 'modules/Testimonials/TestimonialsABTest'

import StandardButton from 'design-system/Buttons/StandardButton'
import Heading2 from 'design-system/Typography/Heading/Heading2'

import Spacer from 'components/Spacer'
import ViewportMarginContainer from 'components/ViewportMarginContainer'

import { TestimonialDataHowItWorks } from 'data/MarketingData/TestimonialData'

const Testimonials: FunctionComponent = () => {
  const theme = useContext(ThemeContext)

  return (
    <ViewportMarginContainer center>
      <Spacer
        size={theme.spacings[32]}
        tabletSize={theme.spacings[48]}
        desktopSize={theme.spacings[72]}
      />
      <Heading2 textAlign="center">Thousands of Happy Homesellers</Heading2>
      <Spacer
        size={theme.spacings[36]}
        tabletSize={theme.spacings[40]}
        desktopSize={theme.spacings[56]}
      />
      <TestimonialsABTest
        type="how-it-works"
        data={TestimonialDataHowItWorks}
      />
      <Spacer
        size={theme.spacings[32]}
        tabletSize={theme.spacings[48]}
        desktopSize={theme.spacings[72]}
      />
      <StandardButton
        type="primary"
        size="medium"
        label="Get Started"
        href="/listing/create"
        boxShadow={theme.shadows.blue.level1}
        center
      />
      <Spacer
        size={theme.spacings[32]}
        tabletSize={theme.spacings[48]}
        desktopSize={theme.spacings[72]}
      />
    </ViewportMarginContainer>
  )
}

export default Testimonials
